import React, { useEffect, useState } from "react";
import CardEmpty from "Utils/Cards/CardEmpty";
import { AlmacenesPadreApi } from "../api/AlmacenesPadreApi";
import Paginacion from "../../../../../Utils/Components/Paginacion/Paginacion";
import LoadMask from "../../../../../Utils/LoadMask/LoadMask";
import { useForm } from "react-hook-form";
import moment from "moment";
import { NotificationManager } from "react-notifications";
import { FiltrosAlmacenesPadre } from "./FiltrosAlmacenesPadre";
import { AlmacenesPadreTable } from "./AlmacenesPadreTable";
import { useDebounce } from "../../../../../Utils/Hooks/useDebounce";
import { getErrorFromResponse } from "../../../../../../../utility/utils";
import { FormAlmacenPadre } from "./FormAlmacenPadre";

import Swal from "sweetalert2";
const alerta = require("assets/img/icons/alerta_roja.png");

export const AlmacenesPadre = ({}) => {
    const { control, watch } = useForm();

    const [almacenesPadre, setAlmacenesPadre] = useState([]);
    const [paginaSeleccionada, setPaginaSeleccionada] = useState(1);
    const [cantidadResultados, setCantidadResultados] = useState(0);

    const [almacenSeleccionado, setAlmacenSeleccionado] = useState(null);

    const search = watch("search");
    const debouncedSearch = useDebounce(search, 500);

    const { getAlmacenesPadre, deleteAlmacenPadre, cargando } =
        AlmacenesPadreApi();

    const GetAlmacenesPadre = async () => {
        try {
            const params = {
                page: paginaSeleccionada,
            };

            if (debouncedSearch) params.search = debouncedSearch;

            const response = await getAlmacenesPadre(params);
            setAlmacenesPadre(response.results);
            setCantidadResultados(response.count);
        } catch (error) {
            // Si el error es por una página inválida, volvemos a la página anterior
            if (
                error &&
                error.detail === "Invalid page." &&
                paginaSeleccionada > 1
            ) {
                setPaginaSeleccionada((prev) => prev - 1);
                return;
            }

            const errorMsg = getErrorFromResponse(
                error,
                "Error al obtener almacenes padre",
            );
            NotificationManager.error(errorMsg, "Error", 3000);

            setAlmacenesPadre([]);
            setCantidadResultados(0);
        }
    };

    const EliminarAlmacenPadre = async (id) => {
        try {
            await deleteAlmacenPadre(id);
            NotificationManager.success(
                "Almacén padre eliminado correctamente",
                "Éxito",
                3000,
            );
            GetAlmacenesPadre();
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al eliminar almacén padre",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
        }
    };

    useEffect(() => {
        GetAlmacenesPadre();
    }, [paginaSeleccionada, debouncedSearch]);

    const [modalNuevoOpened, setModalNuevoOpened] = useState(false);

    const CerrarModal = () => {
        setModalNuevoOpened(false);
        setAlmacenSeleccionado(null);
    };

    const SeleccionarAlmacenEdicion = (almacen) => {
        setAlmacenSeleccionado(almacen);
        setModalNuevoOpened(true);
    };

    return (
        <div className="almacenes-padre__tab-wrapper">
            <LoadMask loading={cargando} blur>
                <CardEmpty noShadow>
                    <div className="almacenes-padre__table-header">
                        <FiltrosAlmacenesPadre
                            control={control}
                            onRefresh={() => {
                                GetAlmacenesPadre();
                            }}
                            resetPage={() => setPaginaSeleccionada(1)}
                            searchPlaceholder={"Almacén"}
                        />
                        <button
                            className="btn btn-primary"
                            onClick={() => setModalNuevoOpened(true)}
                        >
                            Crear nuevo almacén
                        </button>
                    </div>

                    <AlmacenesPadreTable
                        almacenesPadre={almacenesPadre}
                        EliminarAlmacenPadre={EliminarAlmacenPadre}
                        SeleccionarAlmacenEdicion={SeleccionarAlmacenEdicion}
                    />
                    <Paginacion
                        cantidadResultados={cantidadResultados}
                        paginaSeleccionada={paginaSeleccionada}
                        setPaginaSeleccionada={setPaginaSeleccionada}
                    />
                </CardEmpty>
            </LoadMask>
            <FormAlmacenPadre
                opened={modalNuevoOpened}
                onClose={CerrarModal}
                onSuccess={GetAlmacenesPadre}
                almacenSeleccionado={almacenSeleccionado}
            />
        </div>
    );
};
